import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { Colors } from "constants/constants";
import moment from "moment";
import { FC } from "react";

interface UtilizationVanTableWeekProps {
  data: {
    number: string;
    counter: number;
    type: number;
    days_data: {
      counter: number;
      day: number;
    }[];
  }[];
  date: string;
  station: string | undefined;
}

export const UtilizationVanTableWeek: FC<UtilizationVanTableWeekProps> = ({
  data,
  date,
  station,
}) => {
  return (
    <TableContainer style={{ maxHeight: "90vh", boxSizing: "border-box", padding: "0 10px" }}>
      <Table stickyHeader id="fleetPdf">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={4}>
              <Typography style={{ fontWeight: 600 }}>{station}</Typography>
            </TableCell>
            <TableCell align="right" colSpan={3}>
              <Typography style={{ fontWeight: 600 }}>Week {date}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography style={{ fontWeight: 600, textAlign: "center" }}>Type</Typography>
            </TableCell>
            <TableCell>
              <Typography style={{ fontWeight: 600, textAlign: "center" }}>Van</Typography>
            </TableCell>
            {data[0]?.days_data
              ? data[0]?.days_data.map((el) => (
                  <TableCell>
                    <Typography style={{ fontWeight: 600 }}>
                      Day {moment(el?.day).format("DD")}
                    </Typography>
                  </TableCell>
                ))
              : []}
            <TableCell>
              <Typography style={{ fontWeight: 600 }}>Total</Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data
            ? data.map(
                (el) =>
                  el?.counter > 0 && (
                    <TableRow
                      style={{
                        background: el?.counter >= 5 ? Colors.PASTEL_RED : Colors.PASTEL_BLUE,
                      }}
                    >
                      <TableCell
                        style={{
                          background:
                            Number(el?.type) === 1
                              ? Colors.BLUE
                              : Number(el?.type) === 2
                                ? Colors.PASTEL_PINE_TREE
                                : Colors.PASTEL_YELLOW,
                        }}
                      >
                        <Typography style={{ textAlign: "center", color: "#fff" }}>
                          {Number(el?.type) === 1 ? "O" : Number(el?.type) === 2 ? "R" : "U"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography style={{ color: "#fff", textAlign: "center" }}>
                          {el?.number}
                        </Typography>
                      </TableCell>
                      {el?.days_data
                        ? el?.days_data.map((el) => (
                            <TableCell>
                              <Typography style={{ textAlign: "center", color: "#fff" }}>
                                {el?.counter}
                              </Typography>
                            </TableCell>
                          ))
                        : []}
                      <TableCell>
                        <Typography style={{ textAlign: "center", color: "#fff" }}>
                          {el?.counter}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ),
              )
            : []}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
